import { a as _taggedTemplateLiteral } from './chunk-c961656f.js';
import { createGlobalStyle } from 'styled-components';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700|Roboto:400,700');\n  @import url(https://fonts.googleapis.com/icon?family=Material+Icons);\n\n * {\n    box-sizing: border-box;\n    font-family: 'Roboto', sans-serif;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyles = createGlobalStyle(_templateObject());
export default GlobalStyles;